module.exports = __webpack_public_path__ + "img/news-detail-top.b71e7381.png";